/** @format */

const useConstants = () => {
  const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return { isIos };
};

export default useConstants;
